import { useQuery } from 'react-query';
import { useEffect, useState } from 'react';
import usePlanStore from '../../../../../../../store/planStore';
import { DIVISIONS_KEY } from '../../../../../../../api/services/divisions';
import prepareSelectData from '../../../../Plan/Countries/utils/prepareSelectData';
import { getFanpages } from '../../../../../../../api/services/mediaPlanning/getFanpages';
import { Countries } from '../../../../../../../shared/enums';
import { useError } from '../../../../common/Errors/ErrorContext/ErrorContext';

const useFanpages = (country: string, isMetaRF: boolean) => {
  const {
    generalInfoState,
    selectedCountryISOCode,
    setSelectedCountryISOCode,
    updateMetaConfig,
  } = usePlanStore();

  const { showError } = useError();

  const [isoCode, setIsoCode] = useState<string | null>(selectedCountryISOCode);

  useEffect(() => {
    if (country) {
      setSelectedCountryISOCode(country);
    }
  }, [country, setSelectedCountryISOCode]);

  useEffect(() => {
    setIsoCode(selectedCountryISOCode);
  }, [selectedCountryISOCode]);

  const {
    data: response,
    isFetching,
    isLoading,
    isError,
    refetch,
  } = useQuery(
    ['fanpages', country, isoCode, generalInfoState.division],
    () =>
      getFanpages(
        isoCode as Countries,
        generalInfoState.division,
        generalInfoState.category,
        generalInfoState.brand
      ),
    {
      enabled: !!isoCode && !!generalInfoState.division && isMetaRF,
      onError: (error: any) => {
        const errorMessage =
          error?.response?.data?.message || error.message || 'Unknown error';
        showError(errorMessage);
      },
      onSuccess: (res) => {
        if (res.data.length === 1) {
          updateMetaConfig(country, {
            campaignDestination: res.data[0],
          });
        }
      },
    }
  );

  const fanpages = response?.data || [];
  return {
    data: fanpages,
    isFetching,
    isLoading,
    isError,
    refetch,
  };
};

export default useFanpages;
